import { registerTab } from "lib/@components/tabs"
import { REGIME_ASSETS_TAB } from "routes/asset-register/plugins/regime-display/regime-display.runtime"
import { TailoredSchedulesRegimeTab } from "routes/asset-register/plugins/general-tailoring/tailored-schedules-regime-tab"
import { and, or } from "lib/logic"
import { isInEditableRegime } from "routes/facilities/lib/when-parent-item"
import { FEATURE_FLAG_ASSET_MAPPING_TAILORED } from "routes/asset-register/feature-flag-asset-mapping"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/server/feature-flag-tailored-schedule-auditing.mjs"
import { Divider } from "@mui/material"

registerTab({
    tab: REGIME_ASSETS_TAB,
    id: "general-tailoring",
    title: "Tailored",
    predicate: and(
        isInEditableRegime,
        or(
            () => isEnabled(FEATURE_FLAG_ASSET_MAPPING_TAILORED),
            () => isEnabled(FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING)
        )
    ),
    content: <TailoredSchedulesRegimeTab priority={160} />,
})

//Register a vertical bar spacer
registerTab({
    tab: REGIME_ASSETS_TAB,
    id: "general-tailoring_spacer",
    tabProps: { disabled: true },
    title: <Divider orientation="vertical" />,
    predicate: and(isInEditableRegime),
    content: <TailoredSchedulesRegimeTab priority={150} />,
})
